import React from 'react';
import { List } from 'immutable';
import useAppContext from 'flow/hooks/useAppContext';
import { EmailRecipient } from 'flow/types/TicketEventData';
import { TypedMap } from 'flow/types/TypedMap';
import EmailIdentity from 'flow/components/tickets/event-item/Email/EmailIdentity';

interface Props {
    toRecipients: List<TypedMap<EmailRecipient>>;
    ccRecipients: List<TypedMap<EmailRecipient>>;
}

const EmailRecipientsPopoverPanel = ({ toRecipients, ccRecipients }: Props) => {
    const { i18next } = useAppContext();
    return (
        <div className="flex w-max max-w-full flex-col gap-2 rounded-sm bg-white p-3 shadow-lg ring-1 ring-gray-200">
            {toRecipients.size > 0 && (
                <div className="flex flex-col gap-2">
                    <p className="text-xs font-medium text-gray-700">
                        {i18next.t('tickets.message.replyWillBeSentTo')}
                    </p>
                    <div className="ps-3 text-sm">
                        <RecipientList recipients={toRecipients} prefix="to" />
                    </div>
                </div>
            )}
            {ccRecipients.size > 0 && (
                <div className="flex gap-x-3 text-sm">
                    <span className="flex min-w-8 justify-end text-gray-500 lowercase">
                        {i18next.t('tickets.email.cc')}
                    </span>
                    <RecipientList recipients={ccRecipients} prefix="cc" />
                </div>
            )}
        </div>
    );
};

const RecipientList = ({
    recipients,
    prefix,
}: {
    recipients: List<TypedMap<EmailRecipient>>;
    prefix: string;
}) => (
    <div className="flex flex-col break-all">
        {recipients.toArray().map((r) => (
            <div key={`${prefix}-${r.get('address')}`}>
                <EmailIdentity identity={r} />
            </div>
        ))}
    </div>
);

export default React.memo(EmailRecipientsPopoverPanel);
